<template>
    <v-combobox
        v-model="model"
        :items="items"
        :label="label"
        outlined
        @change="changeValue"
        style="border-radius:12px"
        :disabled="disabled"
    >
    </v-combobox>
</template>
<script>
export default {

    props: ["label", "items", "model", "disabled"],

    methods:{
        changeValue(item){
            this.$emit('valueChanged', item);
        }
    }
}
</script>